import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet, useLocation } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useComplianceLayerContext } from 'pages/settings/pages/compliance/context'
import { SettingsPath } from 'pages/settings/route/settingsPath'

export const ComplianceAccessLayout = observer(() => {
  const { pathname, state } = useLocation()
  const store = useComplianceLayerContext()
  const { usersStore } = useEntitiesContext()
  const user = usersStore.user
  const isSummaryReady = Boolean(store.summary?.organization_id)

  useEffect(() => {
    if (!user?.isAdminOrOwnerRole) {
      uiStore.changeRoute({
        path: `/${SettingsPath.personal.profile}`,
        type: 'vue',
      })
    } else if (!isSummaryReady && !store.isUKCountry) {
      uiStore.changeRouteViaVue({
        path: `/${SettingsPath.compliance.questionnaire.root}`,
        options: {
          state: state,
        },
      })
    }
  }, [pathname, user])

  return (
    <>
      <Outlet />
    </>
  )
})
